/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { Actor } from './Actor';
import { Clock } from 'three';
import { Target } from './Target';
import { Events } from '../interaction/Events';
// tslint:disable:no-any
/**
 * Actor that does a linear animation
 */
export class MoveActor extends Actor {
    constructor(stage, obj, name = 'anyMoveActor') {
        super();
        this._clock = new Clock();
        this._durationSec = 1;
        this._targetList = new Array();
        this._stage = stage;
        this._currObj = obj;
        this._name = name;
    }
    static createFromDescription(scene, desc) {
        const obj = scene.getObjectById(desc.objectId);
        const ret = new MoveActor(scene.getStage(), obj, desc.action.name);
        ret.setDuration(desc.action.duration);
        desc.action.target.forEach((e) => {
            ret.addTarget(e.name, e.type, obj[e.name], e.value);
        });
        return ret;
    }
    setDuration(seconds) {
        this._durationSec = seconds;
    }
    addTarget(name, type, source, target) {
        this._targetList.push(new Target(name, type, source, target));
    }
    /**
     * see base class
     */
    update() {
        const t = this._getT();
        this._targetList.forEach((e) => {
            e.interpolate(this._currObj, t);
            this._currObj.updateMatrix();
        });
        if (t >= 1) {
            this._stage.dispatchEvent(Events.ACTORFINISHED, { detail: { id: this._currObj.id, name: this._name } });
            this.discontinue();
        }
    }
    /**
     * see base class
     */
    start() {
        this._clock.start();
    }
    /**
     * see base class
     */
    stop() {
        this._clock.stop();
    }
    /**
     * returns a number between 0 and 1
     */
    _getT() {
        return Math.min(this._clock.getElapsedTime() / this._durationSec, 1);
    }
}
//# sourceMappingURL=MoveActor.js.map